// Constantes métier partagées (codes couleur = palette Inyange)

export const VOIES = {
  memoire: { label: "Mémoire", couleur: "#D4A843" },
  quotidien: { label: "Quotidien", couleur: "#5A7A4A" },
  terrain: { label: "Terrain", couleur: "#B85C38" },
};

export const PLATEFORMES = {
  instagram: "Instagram",
  facebook: "Facebook",
  tiktok: "TikTok",
  youtube: "YouTube",
  newsletter: "Newsletter",
  whatsapp: "WhatsApp",
};

export const STATUTS_PUBLICATION = {
  idee: { label: "Idée", classe: "bg-muted text-muted-foreground" },
  brief: { label: "Brief", classe: "bg-secondary text-secondary-foreground" },
  production: { label: "Production", classe: "bg-accent/25 text-foreground" },
  pret: { label: "Prêt", classe: "bg-success/20 text-success" },
  publie: { label: "Publié", classe: "bg-success text-success-foreground" },
};

export const PRIORITES = {
  basse: { label: "Basse", classe: "bg-muted text-muted-foreground" },
  normale: { label: "Normale", classe: "bg-accent/25 text-foreground" },
  haute: { label: "Haute", classe: "bg-destructive text-destructive-foreground" },
};

export const STATUTS_TACHE = {
  a_faire: { label: "À faire" },
  en_cours: { label: "En cours" },
  termine: { label: "Terminé" },
};

export const NIVEAUX_ANNONCE = {
  info: { label: "Info" },
  important: { label: "Important" },
  urgent: { label: "Urgent" },
};

export const ROLES = {
  admin: "Admin",
  media: "Média",
  membre: "Membre",
  ca: "CA",
  responsable: "Responsable",
  ancien: "Ancien",
};

// 7 pôles utilisés par le composeur de messages (§2.3)
// La clé est envoyée dans le webhook data.pole ; n8n gère le mapping vers l'adresse Brevo.
export const POLES = {
  asbl: "Inyange ASBL",
  ballet: "Ballet Inyange",
  arlon: "Ballet Inyange — Arlon",
  twige: "Inyange Twige",
  finance: "Inyange Finance",
  vie_associative: "Inyange Vie Associative",
  media: "Inyange Média",
};

export const STATUTS_COMPTE = {
  actif: "Actif",
  en_attente: "En attente",
  desactive: "Désactivé",
};

export const EVENEMENTS_WEBHOOK = [
  "announcement.created",
  "task.assigned",
  "ticket_sales.updated",
  "auth.magic_link_requested",
  "user.invited",
  "media_request.created",
];

export const CATEGORIES_AGENDA = {
  asbl: { label: "Inyange ASBL", couleur: "#B85C38" },
  ballet: { label: "Ballet Inyange", couleur: "#D4A843" },
  twige: { label: "Inyange Twige", couleur: "#5A7A4A" },
  media: { label: "Inyange Média", couleur: "#5C1A2A" },
};

export const CATEGORIES_RESSOURCE = {  charte: "Charte graphique",
  logos: "Logos",
  modeles: "Modèles / templates",
  photos: "Photos",
  administratif: "Administratif",
  partitions: "Partitions & chorégraphies",
  autre: "Autre",
};

// Types de demande d'aide média (§Phase 2)
export const TYPES_DEMANDE_MEDIA = {
  affiche: "Affiche / visuel",
  video: "Vidéo / montage",
  photo: "Photos / shooting",
  publication: "Publication réseaux",
  captation: "Captation d'événement",
  communique: "Communiqué / texte",
  autre: "Autre",
};

export const STATUTS_DEMANDE_MEDIA = {
  nouvelle: { label: "Nouvelle", classe: "bg-accent/25 text-foreground" },
  prise_en_charge: { label: "Prise en charge", classe: "bg-secondary text-secondary-foreground" },
  en_cours: { label: "En cours", classe: "bg-secondary text-secondary-foreground" },
  livree: { label: "Livrée", classe: "bg-success/20 text-success" },
};

// Couleurs proposées pour les labels Kanban
export const COULEURS_LABELS = ["#B85C38", "#D4A843", "#5A7A4A", "#5C1A2A", "#D9B8B8", "#2C1A0E"];
